import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';
import Box from '@tds/core-box';
import Button from '@tds/core-button';
import TextButton from '@tds/core-text-button';
import Notification from '@tds/core-notification';
import Spinner from '@tds/core-spinner';
import queryString from 'query-string';

import request, { apiHost } from '../utils/request';
import FieldCheckbox from '../form/fields/fieldCheckbox';
import ValidateLoader from '../UI/validateLoader';
import Loading from './loading';

import { ContentWrapper, SignatureContainer } from '../design/css';
import EN from '../../EN.json';

const SignContract = ({ location: { search } }) => {
  const {
    contractSignature: {
      header,
      consetText,
      errorMessage,
      errorCheck,
      acceptButton,
      loadingMessage,
      submittingMessage,
      signatureText,
      clearText
    }
  } = EN;
  const history = useHistory();
  const [orderId, setOrderId] = useState();
  const [signature, setSignature] = useState(false);
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const signCanvas = useRef();
  const { token } = queryString.parse(search);
  const getContractUrl = id =>
    `${apiHost}/orders/${id}/fully-managed-quote-pdf`;

  useEffect(() => {
    const checkToken = async () => {
      const { data } = await request.get(
        `/orders/validate-token/?token=${token}`
      );

      if (data.success) {
        setOrderId(data.id);
      } else {
        history.push('/sign-contract/expired');
      }
    };
    checkToken();
  }, []);

  const captureSignature = (isConfirmed = false) => {
    if (!isConfirmed && signCanvas.current.isEmpty()) {
      setError(errorMessage);
      return;
    }
    if (!isConfirmed && !isChecked) {
      setError(errorCheck);
      return;
    }

    const signContract = async confirmed => {
      setSubmitting(true);
      const payload = { token, signature, isStatusChanged: confirmed };
      const res = await request.post('/orders/contract-signed', payload);
      setSubmitting(false);
      if (res.data.success) {
        setShowPreview(true);
        setIsChecked(false);
        if (confirmed) history.push('/sign-contract/success');
      } else {
        history.push('/sign-contract/expired');
      }
    };

    signContract(isConfirmed);
  };

  const clearSignature = () => {
    if (!signCanvas.current.isEmpty()) {
      signCanvas.current.clear();
      setSignature(null);
    }
  };

  const onChangeOfSignaturePad = () => {
    setError(false);
    setSignature(signCanvas.current.getTrimmedCanvas().toDataURL());
  };

  const onChange = () => setIsChecked(!isChecked);

  const checkBoxFieldData = {
    checked: isChecked,
    name: 'consent',
    value: 'consent',
    label: consetText,
    onChange
  };

  return !orderId ? (
    <Loading isVisible>
      <ValidateLoader message={loadingMessage} />
    </Loading>
  ) : (
    <>
      {showPreview ? (
        <div className="container 85%" style={{ marginTop: '-2rem' }}>
          <ContentWrapper>
            <Box between={3}>
              <Heading level="h2">Confirm</Heading>
              <Notification variant="branded" copy="en">
                Please confirm if the signature looks correct. if not then you
                can sign it again. if it looks good then just press Submit.
              </Notification>
              <embed
                src={getContractUrl(orderId)}
                type="application/pdf"
                width="100%"
                height="800px"
              />
              <div>
                <Button
                  variant="secondary"
                  onClick={() => setShowPreview(false)}
                >
                  Sign again
                </Button>
                <div style={{ display: 'inline', marginLeft: '1rem' }}>
                  <Button onClick={() => captureSignature(true)}>Submit</Button>
                </div>
              </div>
            </Box>
          </ContentWrapper>
        </div>
      ) : (
        <div className="container 85%" style={{ marginTop: '-2rem' }}>
          <Spinner
            fullScreen={submitting}
            label={submittingMessage}
            spinning={submitting}
          />
          <ContentWrapper>
            <Heading level="h2">{header}</Heading>
            <DimpleDivider />
            <embed
              src={getContractUrl(orderId)}
              type="application/pdf"
              width="100%"
              height="600px"
            />
            <DimpleDivider />
            <Box between={3}>
              <Box between={1}>
                <FieldCheckbox data={checkBoxFieldData} />
              </Box>
              <Heading level="h4">{signatureText}</Heading>
              <SignatureContainer>
                <SignatureCanvas
                  ref={signCanvas}
                  onEnd={onChangeOfSignaturePad}
                  penColor="green"
                  canvasProps={{
                    width: 400,
                    height: 150,
                    className: 'sigCanvas'
                  }}
                />
                {error && (
                  <Notification variant="error" copy="en">
                    {error}
                  </Notification>
                )}
              </SignatureContainer>
              {signature && (
                <div>
                  <TextButton onClick={clearSignature}>{clearText}</TextButton>
                </div>
              )}
              <div>
                <Button onClick={() => captureSignature(false)}>
                  {acceptButton}
                </Button>
              </div>
            </Box>
          </ContentWrapper>
        </div>
      )}
    </>
  );
};

const SignContractSOW = ({ location: { search } }) => {
  const {
    contractSignature: {
      header,
      consetText,
      errorMessage,
      errorCheck,
      acceptButton,
      loadingMessage,
      submittingMessage,
      signatureText,
      clearText
    }
  } = EN;
  const history = useHistory();
  const [orderId, setOrderId] = useState();
  const [signature, setSignature] = useState(false);
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const signCanvas = useRef();
  const { token } = queryString.parse(search);
  const getContractUrl = id =>
    `${apiHost}/orders/${id}/fully-managed-quote-pdf`;

  useEffect(() => {
    const checkToken = async () => {
      const { data } = await request.get(
        `/orders/validate-token/?token=${token}`
      );

      if (data.success) {
        setOrderId(data.id);
      } else {
        history.push('/sign-contract-sow/expired');
      }
    };
    checkToken();
  }, []);

  const captureSignature = (isConfirmed = false) => {
    if (!isConfirmed && signCanvas.current.isEmpty()) {
      setError(errorMessage);
      return;
    }
    if (!isConfirmed && !isChecked) {
      setError(errorCheck);
      return;
    }

    const signContract = async confirmed => {
      setSubmitting(true);
      const payload = { token, signature, isStatusChanged: confirmed };
      const res = await request.post('/orders/contract-signed', payload);
      setSubmitting(false);
      if (res.data.success) {
        setShowPreview(true);
        setIsChecked(false);
        if (confirmed) history.push('/sign-contract-sow/success');
      } else {
        history.push('/sign-contract-sow/expired');
      }
    };

    signContract(isConfirmed);
  };

  const clearSignature = () => {
    if (!signCanvas.current.isEmpty()) {
      signCanvas.current.clear();
      setSignature(null);
    }
  };

  const onChangeOfSignaturePad = () => {
    setError(false);
    setSignature(signCanvas.current.getTrimmedCanvas().toDataURL());
  };

  const onChange = () => setIsChecked(!isChecked);

  const checkBoxFieldData = {
    checked: isChecked,
    name: 'consent',
    value: 'consent',
    label: consetText,
    onChange
  };

  return !orderId ? (
    <Loading isVisible>
      <ValidateLoader message={loadingMessage} />
    </Loading>
  ) : (
    <>
      {showPreview ? (
        <div className="container 85%" style={{ marginTop: '-2rem' }}>
          <ContentWrapper>
            <Box between={3}>
              <Heading level="h2">Confirm</Heading>
              <Notification variant="branded" copy="en">
                Please confirm if the signature looks correct. if not then you
                can sign it again. if it looks good then just press Submit.
              </Notification>
              <embed
                src={getContractUrl(orderId)}
                type="application/pdf"
                width="100%"
                height="800px"
              />
              <div>
                <Button
                  variant="secondary"
                  onClick={() => setShowPreview(false)}
                >
                  Sign again
                </Button>
                <div style={{ display: 'inline', marginLeft: '1rem' }}>
                  <Button onClick={() => captureSignature(true)}>Submit</Button>
                </div>
              </div>
            </Box>
          </ContentWrapper>
        </div>
      ) : (
        <div className="container 85%" style={{ marginTop: '-2rem' }}>
          <Spinner
            fullScreen={submitting}
            label={submittingMessage}
            spinning={submitting}
          />
          <ContentWrapper>
            <Heading level="h2">{header}</Heading>
            <DimpleDivider />
            <embed
              src={getContractUrl(orderId)}
              type="application/pdf"
              width="100%"
              height="600px"
            />
            <DimpleDivider />
            <Box between={3}>
              <Box between={1}>
                <FieldCheckbox data={checkBoxFieldData} />
              </Box>
              <Heading level="h4">{signatureText}</Heading>
              <SignatureContainer>
                <SignatureCanvas
                  ref={signCanvas}
                  onEnd={onChangeOfSignaturePad}
                  penColor="green"
                  canvasProps={{
                    width: 400,
                    height: 150,
                    className: 'sigCanvas'
                  }}
                />
                {error && (
                  <Notification variant="error" copy="en">
                    {error}
                  </Notification>
                )}
              </SignatureContainer>
              {signature && (
                <div>
                  <TextButton onClick={clearSignature}>{clearText}</TextButton>
                </div>
              )}
              <div>
                <Button onClick={() => captureSignature(false)}>
                  {acceptButton}
                </Button>
              </div>
            </Box>
          </ContentWrapper>
        </div>
      )}
    </>
  );
};

SignContract.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

SignContractSOW.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export { SignContract, SignContractSOW };
